/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Welcome Sign',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path d="M10.05 7.5c0 .322-.254.521-.55.55h-3a.55.55 0 0 1 0-1.1h3c.296.029.55.227.55.55zm1.5-2c0 .322-.253.521-.55.55H5a.55.55 0 0 1 0-1.1h6c.296.029.55.227.55.55z" />
          <path
            fillRule="evenodd"
            d="M10.55 1v1.45H14c.296.029.55.227.55.55v6.45H15c.296.029.55.227.55.55v2c-.029.296-.227.55-.55.55h-2.237l.759 2.276c.117.35-.152.724-.521.724h-2a.55.55 0 0 1-.521-.376l-.875-2.624H6.396l-.875 2.624A.55.55 0 0 1 5 15.55H3c-.369 0-.638-.373-.521-.724l.759-2.276H1A.55.55 0 0 1 .45 12v-2c.029-.296.227-.55.55-.55h.45V3c.029-.296.227-.55.55-.55h3.45V1c.029-.296.227-.55.55-.55h4c.296.029.55.227.55.55zM3.763 14.45h.841l.634-1.9h-.842l-.633 1.9zm7.634 0h.841l-.633-1.9h-.842l.634 1.9zm-9.847-3h12.9v-.9H1.55v.9zm1-2h10.9v-5.9H2.55v5.9zm4-7h2.9v-.9h-2.9v.9z"
          />
        </>
      )
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M14.797 11.5c0 .352-.278.568-.601.6H9.803a.6.6 0 0 1 0-1.2h4.394c.323.031.601.248.601.6zm1.803-3c0 .352-.276.568-.6.6H8a.6.6 0 0 1 0-1.2h8c.323.031.6.248.6.6z" />
          <path
            fillRule="evenodd"
            d="M14.1 2.5v1.399H20c.323.031.6.248.6.6v10.4h.4c.323.031.6.248.6.6v2c-.031.323-.248.6-.6.6h-2.644l1.07 3.21c.127.382-.167.789-.569.789h-2.571a.6.6 0 0 1-.569-.41l-1.197-3.589H9.338l-1.197 3.59a.6.6 0 0 1-.569.41L5 22.1c-.402 0-.696-.407-.569-.789l1.07-3.212H3a.6.6 0 0 1-.6-.6v-2c.031-.323.248-.6.6-.6h.4v-10.4c.031-.323.248-.6.6-.6h5.9V2.5c.031-.323.248-.6.6-.6h3c.323.031.6.248.6.6zM5.832 20.899h1.307l.886-2.657H6.718l-.886 2.657zm10.887-.001h1.307l-.886-2.657h-1.307l.886 2.657zM3.6 16.899H20.4v-.801H3.6v.801zm1-2H19.4V5.099H4.6v9.801zm6.5-11H12.9v-.8H11.1v.8z"
          />
        </>
      )
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path d="M20.601 16c0 .351-.277.568-.6.6h-8a.6.6 0 1 1 0-1.2h8c.323.031.6.248.6.6zm1.999-3c0 .352-.277.568-.6.6H10a.6.6 0 0 1 0-1.2h12c.323.031.6.248.6.6zm-4-3c0 .352-.277.568-.6.6h-4a.6.6 0 0 1 0-1.2h4c.323.031.6.248.6.6z" />
          <path
            fillRule="evenodd"
            d="M18.6 2.5v1.4h9.4c.323.031.6.248.6.6v16.4h1.4c.323.031.6.248.6.6v2c-.031.323-.248.599-.6.6h-4.24l1.807 5.203c.138.397-.166.775-.567.797h-2.917a.6.6 0 0 1-.566-.402L21.574 24.1H10.426l-1.942 5.598a.6.6 0 0 1-.566.402H5c-.402-.022-.705-.399-.567-.797L6.24 24.1H2a.6.6 0 0 1-.601-.6v-2c.034-.323.248-.6.601-.6h1.4V4.5c.031-.323.248-.6.6-.6h9.4V2.5c.031-.323.248-.6.6-.6h4c.323.031.6.248.6.6zM5.842 28.9h1.646L9.156 24.1H7.509L5.842 28.9zm18.669 0h1.646L24.491 24.1h-1.646l1.667 4.801zM2.6 22.9h26.801V22.1H2.6v.801zm2-2h22.801V5.1H4.6V20.9zm10-17h2.801V3.1H14.6V3.9z"
          />
        </>
      )
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path d="M30.003 23.471c.345 0 .625.28.625.625s-.28.625-.625.625h-12c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h12zm2-4.154c.345 0 .625.28.625.625s-.28.625-.625.625h-16c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h16zm-4.375-3.471c0 .366-.289.591-.625.625h-6c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h6c.336.034.625.258.625.625z" />
          <path
            fillRule="evenodd"
            d="M27.628 4.846v2.375h13.374c.336.034.625.258.625.625v23.375h2.376a.64.64 0 0 1 .593.822l-1 3c-.085.255-.324.428-.593.428h-6.006l2.597 7.477c.144.416-.181.803-.592.83h-4.038c-.266 0-.504-.169-.591-.42l-2.738-7.888H15.372l-2.739 7.888c-.087.251-.325.42-.591.42H8.003c-.418-.027-.735-.413-.591-.83l2.596-7.477H5.003c-.282 0-.488-.181-.593-.428l-1-3c-.132-.398.174-.822.593-.822h2.374V7.846c.034-.336.258-.625.625-.625h13.376l.013-2.501c.058-.285.31-.499.612-.499h6c.336.034.625.258.625.625zM8.882 42.528h2.715l2.45-7.058h-2.716l-2.449 7.058zm26.527 0h2.715l-2.449-7.058h-2.716l2.45 7.058zM5.454 34.221h37.1l.583-1.75H4.871l.583 1.75zm2.174-3h32.75V8.471H7.627v22.75zm14.001-24h4.75v-1.75h-4.75v1.75z"
          />
        </>
      )
    },
    '64': {
      viewBox: '0 0 64 64',
      path: (
        <>
          <path d="M40.946 30.786c0 .452-.366.779-.8.8H23.855a.8.8 0 1 1 0-1.6h16.291c.434.021.8.348.8.8zm2.715-5.638c0 .452-.366.779-.8.8H21.14a.8.8 0 1 1 0-1.6h21.722c.434.021.8.348.8.8zm-6.788-5.561c0 .452-.366.779-.8.8h-8.146a.8.8 0 1 1 0-1.6h8.146c.434.021.8.348.8.8z" />
          <path
            fillRule="evenodd"
            d="M36.8 6.978v2.2H55c.434.021.8.348.8.8v30.2H59c.501.027.905.481.776.994l-1 4a.8.8 0 0 1-.776.605h-7.058l3.813 10.983A.81.81 0 0 1 54 57.822h-5.833a.8.8 0 0 1-.756-.537l-3.996-11.508h-22.83l-3.996 11.508a.8.8 0 0 1-.756.537H10a.81.81 0 0 1-.756-1.062l3.813-10.983H6a.8.8 0 0 1-.776-.605l-1-4A.81.81 0 0 1 5 40.178h3.2l.004-30.282A.8.8 0 0 1 9 9.178h18.2l.004-2.282A.8.8 0 0 1 28 6.178h8c.434.021.8.348.8.8zM11.124 56.223h4.139l3.612-10.4h-4.139l-3.612 10.4zm37.613 0h4.139l-3.612-10.4h-4.139l3.612 10.4zM6.625 44.178h50.75l.601-2.4H6.024l.601 2.4zm3.175-4h44.4v-29.4H9.8v29.4zm19-31h6.4v-1.4h-6.4v1.4z"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
